import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../.services/settings.service';
import { ConnectionService } from '../.services/connection.service';



@Component({
  selector: 'app-user-controls',
  templateUrl: './user-controls.component.html',
  styleUrls: ['./user-controls.component.css']
})


export class UserControlsComponent implements OnInit {

  connection: ConnectionService;
  settings: SettingsService;
  videoMuted: boolean;
  isHost: boolean;
  jumpedIn: boolean;
  screenshareLocked: boolean;
  primaryLocked: boolean;
  hostControlsOpen: boolean;
  selectedLayoutName: string;
  clearedMasterVideoContainer: any;
  screenshareop: boolean;
  //requestConstraints: Array<boolean>;


  closeConnection = () => {
    location.reload();
  }


  toggleBugReportForm = () => {
    this.settings.toggleReportForm();
  }

  newOpenScreenshare = () => {
    if(!this.screenshareLocked) {
      let connection = this.connection.connection;
      let myId = this.settings.getId();
      let ssId = this.settings.getStreamId();
          this.settings.changeLayout("Secondary");
          this.settings.changeScreenshareOpenState(true);
    
      let newFrame = document.getElementById('screenshareWindow') as HTMLIFrameElement;

      //Tell Iframe to open screenshare
      setTimeout(()=> {
        newFrame.contentWindow.postMessage({type: "openScreenshare", screenshareId: ssId}, "*") //open the screenshare for the host in iframe
        let broadcastScreenshareId = setTimeout(()=>{
            connection.sendCustomMessage({type: "screenshareReq", msg: {requesterId: myId, screenshareId: ssId, session: this.connection.connection.sessionid}}); //send ssId to other clients.
        }, 2000)

        this.settings.changeScreenshareOpenState(true);
      }, 3000)
    }
  }

  openScreenshare = () => {
    if(!this.screenshareLocked) {
      let connection = this.connection.connection;
      let myId = this.settings.getId();
      let ssId = this.settings.getStreamId();
          this.settings.changeLayout("Secondary");
      
      //primary is still under the ss element
    /*
      let primary = document.getElementById('v1_16');
      let frame = document.createElement('iframe');
        frame.src = "/screenshare.html";
        //frame.src = "./assets/screenshare.html";
        frame.id = "screenshareframe";
        frame.style.width = "100%";
        frame.style.position = "absolute";
        primary.appendChild(frame);
    */
        this.settings.setScreenshareIsOpen(true);
    
        //remove popout icon?

        let newFrame = document.getElementById('screenshareWindow') as HTMLIFrameElement;

      //Tell Iframe to open screenshare
      setTimeout(()=> {
        newFrame.contentWindow.postMessage({type: "frameScreenshareData", screenshareId: ssId}, "*") //open the screenshare for the host in iframe
        let broadcastScreenshareId = setTimeout(()=>{
            connection.sendCustomMessage({type: "screenshareReq", msg: {requesterId: myId, screenshareId: ssId, session: this.connection.connection.sessionid}}); //send ssId to other clients.
        }, 2000)

        /*
         frame.contentWindow.postMessage({type: "frameScreenshareData", screenshareId: ssId}, "*") //open the screenshare for the host in iframe
         let broadcastScreenshareId = setTimeout(()=>{
             connection.sendCustomMessage({type: "screenshareReq", msg: {requesterId: myId, screenshareId: ssId, session: this.connection.connection.sessionid}}); //send ssId to other clients.
         }, 2000)
         */
      }, 3000)
    }
  }

  requestPrimary = () => {
     let id = this.settings.getId();
      this.connection.requestPrimary(id);
      this.connection.takePrimary(id);
  }

  hideLocalVideo = (event) => {
    this.connection.connection.attachStreams.forEach((stream) => {
      

        if (stream.type === "local"  && !this.videoMuted ) {
            stream.mute();
            this.videoMuted = true;
           
        } else if (stream.type === "local" && this.videoMuted ) {
            stream.unmute();
            this.videoMuted = false;
        }
    });
  }

  jump = () => {
    let id = this.settings.getId();
    let jumpingTo = !this.settings.jumpedIn.value;
    this.connection.jump(id);
    this.settings.changeJumpedInStatus(jumpingTo);
  
  }



  constructor(private connectionService: ConnectionService, private settingsService: SettingsService) {
    this.connection = connectionService;
    this.settings = settingsService;
    this.selectedLayoutName = "Primary";
 }

 redirectClick = () => {
   document.getElementById('selectVideoModeBtn').click();
 }

 changeLayout = (e) => {
    if(this.isHost) {
      this.settings.changeLayout(e.target.innerText);
      this.selectedLayoutName = e.target.innerText;
      this.connection.connection.sendCustomMessage({type: "changeView", msg: {from: this.settings.getId(), layout: e.target.innerText}})
      this.redirectClick();
    } else {
      this.redirectClick();
    }
 }

 lockPrimary = (e) => {
   e.stopPropagation();
   if(this.isHost) { 

    this.settings.togglePrimaryLock();
    let lockSetting = this.settings.primaryLocked.value;

     if(this.settings.primaryLocked != undefined) {   
       this.connection.connection.sendCustomMessage({type: "primaryLockState", msg: {from: this.settings.getId(), setLocked: lockSetting}});
     }
     
   }
 }

 lockScreenshare = (e) => {
   e.stopPropagation();
   if(this.isHost) {
      this.settings.toggleScreenshareLock();
      let lockSetting = this.settings.screenshareLocked.value;

     if(this.settings.screenshareLocked != undefined) {   
       this.connection.connection.sendCustomMessage({type: "screenshareLockState", msg: {from: this.settings.getId(), setLocked: lockSetting}});
     }


   }
 }

   test = () => {
     console.log(this.settings.screenshareOpen.value)

  }

  ngOnInit() {
    this.videoMuted = false;
    this.hostControlsOpen = false;
  //  this.primaryLocked = this.settings.primaryLocked; //change to observable
    this.clearedMasterVideoContainer = document.getElementById('MasterVideoContainer').cloneNode(true);
    this.connection.cast.subscribe((host)=> {
      this.isHost = host;
    });

    this.settings.cast.subscribe((layout)=> {});
    this.settings.primaryCast.subscribe(val => {
      this.primaryLocked = val;
    });

    this.settings.jumpedInCast.subscribe(jumpStatus => {
      this.jumpedIn = jumpStatus;
    });

    this.settings.screenshareCast.subscribe(lockStatus => {
      this.screenshareLocked = lockStatus;
    });

    this.settings.screenShareIsOpenCast.subscribe(state => {
      this.screenshareop = state;
    });
 




  }

}
